// removed by extract-text-webpack-plugin
module.exports = {"alertWrap":"qempo_Courier_alertWrap-kqK0YMT"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/courier/components/Courier.scss
// module id = 2228
// module chunks = 0